import { BotIcon, CableIcon, HammerIcon, SettingsIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { ComingSoonBadge } from '@/components/atoms/coming-soon-badge.atom'
import { Button } from '@/components/ui/button'

interface HeaderNavButtonsProps {
  onAgenciesClick: () => void
  onOrgSettings: () => void
  onToolsClick: () => void
  onConnectsClick: () => void
}

export const HeaderNavButtons = ({
  onAgenciesClick,
  onOrgSettings,
  onToolsClick,
  onConnectsClick,
}: HeaderNavButtonsProps): ReactNode => (
  <div className="header-nav-buttons flex items-center gap-2">
    <Button
      variant="ghost"
      className="agencies-button gap-2 text-muted-foreground hover:text-foreground"
      onClick={onAgenciesClick}
    >
      <BotIcon className="size-4" />
      <span className="hidden xl:inline">Agencies</span>
    </Button>
    <div className="relative">
      <Button
        variant="ghost"
        className="tools-button gap-2 text-muted-foreground hover:text-foreground"
        onClick={onToolsClick}
      >
        <HammerIcon className="size-4" />
        <span className="hidden xl:inline">Tools</span>
      </Button>
      <ComingSoonBadge className="hidden xl:flex" />
    </div>
    <Button
      variant="ghost"
      className="connects-button gap-2 text-muted-foreground hover:text-foreground"
      onClick={onConnectsClick}
    >
      <CableIcon className="size-4" />
      <span className="hidden xl:inline">Connects</span>
    </Button>
    <Button
      variant="ghost"
      size="icon"
      className="settings-button text-muted-foreground hover:text-foreground"
      onClick={onOrgSettings}
    >
      <SettingsIcon className="size-4" />
    </Button>
  </div>
)
